module.exports = __webpack_public_path__ + "img/img-22.77920c33.svg";